import { render, staticRenderFns } from "./DevOps.vue?vue&type=template&id=952ecf80&"
import script from "./DevOps.vue?vue&type=script&lang=js&"
export * from "./DevOps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports